<template>
  <div>
    <!-- <base-title
      style="cursor:pointer"
      @click="$router.go(-1)"
    >Back</base-title> -->
    <v-row>
      <!-- Summary of summaries -->
      <v-col cols="3" class="pt-15">
        <v-card
          id="summary"
          color="grey lighten-4"
        >
          <v-card-title
            v-show="$vuetify.breakpoint.smAndUp"
            class="primary--text"
          >
            Send to Patient
          </v-card-title>
          <v-list dense>
            <v-list-item
              dense
              v-for="(summary, index) in summaries"
              :key="index"
            >
              <!-- summary item -->
              <v-list-item-avatar>
                <v-checkbox
                  v-model="summary.sendToPatient"
                  dense
                ></v-checkbox>
              </v-list-item-avatar>
              <v-list-item-title>{{summary.title}}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="8">
        
        <v-tabs 
          id="tabNav"
          centered
          v-model="activeSummary"
        >
          <v-tab
            v-for="(summary, index) in summaries"
            :key="index"
          >
            <label class="text-caption">{{ summary.title }}</label>
          </v-tab>
        </v-tabs>


        <v-tabs-items v-model="activeSummary">
          <v-tab-item
            v-for="(summary, index) in summaries"
            :key="index"
          >
            <v-card height="80vw">
              <v-card-text class="fill-height">
                <v-row
                  v-if="files[summary.data]"
                  class="fill-height ma-0 pa-0"
                >
                  <iframe
                    width="100%"
                    height="100%"
                    :src="files[summary.data]"
                    :title="summary.title"
                    scrolling="no"
                  ></iframe>
                </v-row>
                <!-- PLACEHOLDER ONLY -->
                <v-row v-else class="fill-height" align="center" justify="center">
                  <v-overlay :value="true" opacity="0.1" color="grey" absolute>
                    <h2 class="grey--text text--darken-2">NO DATA AVAILABLE</h2>
                  </v-overlay>
                  <v-skeleton-loader 
                    boilerplate
                    height="100%"
                    width="100%"
                    type="table-heading, card, list-item-two-line, list-item-two-line, card, card"
                  ></v-skeleton-loader>
                </v-row>
                <!-- PLACEHOLDER ONLY -->
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: 'FormCaseSummary',

    props: {
      files: { type: Object }
    },

    data: ()=>({
      activeSummary: 0,
      summaries: [
        {title: 'Care Plan', data: 'teleconsultation', sendToPatient: false,},
        {title: 'Prescriptions', data: 'prescription', sendToPatient: false,},
        {title: 'Medical Certificate', data: 'certificate', sendToPatient: false,},
        {title: 'Laboratory Request', data: 'laboratory', sendToPatient: false,},
      ]
    })
  }
</script>

<style lang="scss" scoped>
  #summary {
    position:-webkit-sticky;
    position: sticky;
    top: 4vh;
  }

  .pdfSendContainer {
    position:relative;
    bottom:80px;
    height:80px;
    background-color: rgba(150,150,150,0.7);
    z-index: 9999;
    opacity: 0.5  ;
  }

  .pdfSendContainer:hover {
    opacity: 1;
  }
</style>